import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../util/assets';

const propTypes = {
  asset: PropTypes.string,
  title: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired,
};

const NonResult = ({ asset = '/waldo-icon-error.svg', title, error }) => {
  return (
    <div className="row search-results-no-results">
      <div className="col-12 mb-2">
        <img alt={title} src={getAsset(asset)} />
      </div>
      <div className="col-12">
        <h4>{title}</h4>
      </div>
      <div className="col-12">
        <span>{error}</span>
      </div>
    </div>
  );
};

NonResult.propTypes = propTypes;

export default NonResult;
